import wretch from "wretch";

const APP_EVENTS_URL = process.env.NEXT_PUBLIC_EXTERNAL_BFF_URL
  ? `${process.env.NEXT_PUBLIC_EXTERNAL_BFF_URL}/app-events`
  : undefined;

export interface TrackAppEventParams {
  accessToken?: string | null;
  eventName: string;
  data?: Record<string, unknown>;
}

export const trackAppEvent = async ({
  accessToken,
  eventName,
  data = {}
}: TrackAppEventParams): Promise<void> => {
  if (!APP_EVENTS_URL || !accessToken) return;

  try {
    await wretch(APP_EVENTS_URL)
      .headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      })
      .post({
        event_name: eventName,
        data: JSON.stringify({
          platform: "web",
          ...data
        })
      })
      .res();
  } catch (error) {
    // Analytics must never interrupt the practice flow when the tracker is
    // unavailable. The request is still visible in the browser console.
    console.error(`Failed to capture app event ${eventName}`, error);
  }
};
